<p-iconfield iconPosition="left" style="width: 100%;">
  @if (showIcon()) {
    <p-inputicon>
      <app-mail-01 stroke="#ADB0B8"></app-mail-01>
    </p-inputicon>
  }
  <input
    [pAutoFocus]="shouldFocus()"
    (blur)="handleBlur($event)"
    (keyup)="handleKeyUp($event)"
    [formControl]="formCtrl()"
    [id]="inputId()"
    [type]="formCtrlType()"
    [placeholder]="ctrlPlaceholder()"
    autocomplete="off"
    pInputText
    class="w-full"
    [disabled]="isDisabled()"
  >
</p-iconfield>
@if (!hideErrors()) {
  @if (formCtrl().touched && formCtrl().invalid) {
    <app-error-email [formCtrl]="formCtrl()"></app-error-email>
  }
  <app-error-required [formCtrl]="formCtrl()"></app-error-required>
}
